import { COLOR } from 'admin/constants/styles';
import React, { forwardRef } from 'react';
import styled, { StyledComponentPropsWithRef } from 'styled-components';
import { InputErrors } from './WithErrors';

type Props = {
  syncValue?: string;
  unit?: string;
  className?: string;
  innerRef?: React.RefObject<HTMLInputElement>;
} & Omit<React.ComponentProps<typeof InputErrors>, 'children'>;

type InputProps = {
  align?: 'left' | 'right' | 'center';
};

const Input = styled.input.attrs<InputProps>((props) => ({
  type: props.type || 'text',
  placeholder: props.placeholder || '',
  size: props.size || 20,
}))<InputProps>`
  padding: 5px;
  border-radius: 3px;
  border: 1px solid ${COLOR.lightGray};
  outline: none;
  background: ${(props) => (props.disabled ? '#eee' : 'none')};
  text-align: ${(props) => props.align || 'left'} !important;
`;

const Unit = styled.span`
  color: #aaa;
  font-size: 20px;
  font-weight: 500;
  text-align: center;
  margin: 0 8px;
  vertical-align: middle;
`;

const TextBox = forwardRef<
  HTMLInputElement,
  Props & InputProps & StyledComponentPropsWithRef<typeof Input>
>(({ value, syncValue, innerRef, className, unit, errors, fullWidth = false, ...rest }, ref) => {
  const optionalAttrs = syncValue === undefined ? {} : { value: syncValue };
  return (
    <InputErrors errors={errors} fullWidth={fullWidth}>
      <Input
        ref={innerRef || ref}
        defaultValue={value}
        className={className}
        {...optionalAttrs}
        {...rest}
      />
      {unit ? <Unit>{unit}</Unit> : null}
    </InputErrors>
  );
});

export default styled(TextBox)<{ fullWidth?: boolean }>`
  ${({ fullWidth }) => fullWidth && 'width: 100%;'}
`;
